<template>
  <div>
    <el-form
    :inline="true"
    >
      <el-form-item>
        <el-input placeholder="输入批次名" v-model="batch_name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
        type="primary"
        v-if="btn_permission.includes('middle:coldLot:add')||btn_permission.includes('superAdmin')"
        @click="create_batch">点击创建新的批次</el-button>
      </el-form-item>
    </el-form>
    <!-- 批次列表 -->
    <el-table
    v-loading="batch_detail_loading"
    :data="batch_list"
    ref="batch_table"
    highlight-current-row
    max-height="300"
    @row-click="batch_left_click"
    @row-contextmenu="batch_right_click"
    >
      <el-table-column align="center" type="index" label="NO"></el-table-column>
      <el-table-column
      align="center"
      width="200"
      sortable
      prop="lotName"
      show-overflow-tooltip
      label="批次名"></el-table-column>
      <el-table-column
      align="center"
      sortable
      prop="count"
      label="包含数"></el-table-column>
      <el-table-column
      align="center"
      sortable
      prop="addWho"
      show-overflow-tooltip
      label="创建人"></el-table-column>
      <el-table-column
      align="center"
      sortable
      prop="addTime"
      show-overflow-tooltip
      label="创建时间"></el-table-column>
    </el-table>
    <!-- 批次列表分页 -->
    <el-pagination
    style="margin: 10px auto;"
    background
    @size-change="batch_size_change"
    @current-change="batch_current_change"
    :current-page="batch_current_page"
    :page-sizes="[10, 15, 20, 25]"
    :page-size="batch_page_size"
    layout="total, sizes, prev, pager, next, jumper"
    :total="batch_total"
    ></el-pagination>
    <!-- 批次列表右键菜单 -->
    <div id="batch_menu">
      <ul>
        <li @click="delete_now_batch" v-if="btn_permission.includes('middle:coldLot:del')||btn_permission.includes('superAdmin')">
          <span>删除该批次</span>
        </li>
        <li @click="check_now_batch" v-if="btn_permission.includes('middle:coldLot:detailCount')||btn_permission.includes('superAdmin')">
          <span>查看批次明细</span>
        </li>
        <li @click="export_now_batch" v-if="btn_permission.includes('middle:coldLot:import')||btn_permission.includes('superAdmin')">
          <el-upload
          :action="publicAjax.extra_path+'/middle/coldChainLot/import/'+row_batch_now.lotName"
          :auto-upload="true"
          :headers="{'scctoken':upload_token}"
          name="file"
          accept=".xls"
          :on-success="success_file"
          :file-list="batch_file"
          :show-file-list="false"
          ref="batch_upload"
          >
            <span style="margin-left: -8px;">导入明细到该批次</span>
          </el-upload>
        </li>
        <li
        v-if="btn_permission.includes('middle:coldLot:canDownLoad|middle:coldLot:download')&&btn_permission.includes('middle:coldLot:download')||btn_permission.includes('superAdmin')"
        @click="download_now_batch">
          <span>下载批次明细</span>
        </li>
      </ul>
    </div>
    <el-button
    icon="el-icon-download"
    type="primary"
    v-if="btn_permission.includes('middle:coldLot:template')||btn_permission.includes('superAdmin')"
    @click="template_download">模板下载</el-button>
  </div>
</template>

<script>
  export default {
    name:'batch',
    data() {
      return{
        //权限数组
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        batch_name:'',
        batch_list:[],
        //批次列表分页
        batch_current_page:1,
        batch_page_size:10,
        batch_total:10,
        row_batch_now:[],
        //导入明细到该批次
        upload_token:localStorage.getItem(localStorage.getItem('userName')+'token'),
        batch_file:[],
        //下载批次明细懒加载
        batch_detail_loading:false
      }
    },
    //注册组件
    components:{

    },
    created() {
      this.publicAjax.axios_set()
      //批次列表
      this.get_batch_list()
    },
    mounted() {

    },
    methods:{
      //创建新的批次
      create_batch(){
        if(!this.batch_name){
          this.$message.warning('您还未输入批次名!')
          return false
        }
        let that=this
        that.$axios({
          method:'post',
          url:that.publicAjax.extra_path+'/middle/coldChainLot',
          data:{
            lotName:that.batch_name
          },
          headers:{
            "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
            "content-type":"application/json;charset=UTF-8"
          }
        }).then(data=>{
          if(data.data.success==true){
            that.$message.success(data.data.message)
            //批次列表
            that.get_batch_list()
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      // 批次列表鼠标左键点击事件
      batch_left_click(row,column,event){
        var menu=document.querySelector('#batch_menu')
        menu.style.display='none'
      },
      //批次列表鼠标右键点击事件
      batch_right_click(row,column,event){
        this.row_batch_now=row
        var menu=document.querySelector('#batch_menu')
        event.preventDefault()
        //根据事件对象中鼠标点击的位置，进行定位
        let menu_top=document.body.clientHeight-event.clientY
        if(menu_top<150){
          menu.style.top=event.clientY-40+'px'
        }else{
          menu.style.top=event.clientY+60+'px'
        }
        menu.style.left=event.clientX-200+'px'
        //改变自定义菜单的显示和隐藏
        menu.style.display='block'
        this.$refs.batch_table.setCurrentRow(row)
      },
      //批次列表分页
      batch_size_change(val){
        this.batch_page_size=val
        //批次列表
        this.get_batch_list()
      },
      batch_current_change(val){
        this.batch_current_page=val
        //批次列表
        this.get_batch_list()
      },
      //批次列表
      get_batch_list(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/coldChainLot/list',
          params:{
            page:that.batch_current_page,
            limit:that.batch_page_size
          }
        }).then(data=>{
          if(data.data.success==true){
            that.batch_list=data.data.data.list
            that.batch_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //删除该批次
      delete_now_batch(){
        var menu=document.querySelector('#batch_menu')
        menu.style.display='none'
        let that=this
        that.$confirm('确定删除批次 '+that.row_batch_now.lotName+' 吗?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/coldChainLot/'+that.row_batch_now.id
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
              //批次列表
              that.get_batch_list()
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //查看批次明细(自定义菜单点击事件)
      check_now_batch(){
        var menu=document.querySelector('#batch_menu')
        menu.style.display='none'
        let router_list=[]
        this.$store.state.openTab.forEach((item,index)=>{
          router_list.push(item.route)
        })
        if(router_list.includes('/cold/batch_details')){
          this.$store.commit('delete_tabs','/cold/batch_details')
        }
        this.$store.commit('add_tabs',{
          route:'/cold/batch_details',
          name:'批次 '+this.row_batch_now.lotName+' 包含的事务'
        })
        this.$store.commit('set_active_index','/cold/batch_details')
        this.$router.push({
          path:'/cold/batch_details',
          query:{
            lotId:this.row_batch_now.id
          }
        })
      },
      //导入明细到该批次
      export_now_batch(){
        var menu=document.querySelector('#batch_menu')
        menu.style.display='none'
      },
      //导入明细成功回调
      success_file(data,file,fileList){
        if(data.success==true){
          this.$message.success(data.message)
          //批次列表
          this.get_batch_list()
        }else{
          this.$message.error(data.message)
        }
      },
      //下载批次明细
      download_now_batch(){
        var menu=document.querySelector('#batch_menu')
        menu.style.display='none'
        let zipName=this.row_batch_now.lotName+'的批次明细.zip'
        //是否可以下载批次明细
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/coldChainLot/canDownload/'+that.row_batch_now.id
        }).then(data=>{
          if(data.data.success==true){
            that.batch_detail_loading=true
            that.$axios({
              method:'get',
              responseType:'blob',
              url:that.publicAjax.extra_path+'/middle/coldChainLot/download/'+that.row_batch_now.id
            }).then(data=>{
              that.batch_detail_loading=false
              that.pdfUrl=window.URL.createObjectURL(new Blob([data.data]), {type:"application/zip"})
              let link=document.createElement('a')
              link.href=that.pdfUrl
              link.style.display='none'
              link.setAttribute('download',zipName)
              document.body.appendChild(link)
              link.click()
              URL.revokeObjectURL(link.href)
              document.body.removeChild(link)
            })
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //模板下载
      template_download(){
        let that=this
        that.$axios({
          url:that.publicAjax.extra_path+'/middle/coldChainLot/template',
          method:'get',
          responseType:'blob'
        }).then(data=>{
          that.pdfUrl=window.URL.createObjectURL(new Blob([data.data], {type:"application/vnd.ms-excel"}))
          let link=document.createElement('a')
          link.href=that.pdfUrl
          link.style.display='none'
          let fname='批次数据导入模板.xls'
          link.setAttribute('download',fname)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        })
      }
    }
  }
</script>

<style scoped="scoped">
  /* 右键菜单 */
  #batch_menu{
    position: absolute;
    display: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    background: #FFFFFF;
    cursor: pointer;
    color: #606266;
    width: 200px;
    border: 1px solid #e4e7ed;
    font-size: 14px;
    z-index: 999;
  }
  #batch_menu ul{
    list-style: none;
    margin: 0px;
    padding: 0px;
  }
  #batch_menu ul li{
    padding: 0px 10px;
    height: 30px;
    line-height: 30px;
    position: relative;
    box-sizing: border-box;
    text-indent: 8px;
  }
  #batch_menu ul li:hover{
    background-color: #ecf5ff;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/batch.vue